import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
//import { CommonRequest } from "@/types/http";
import {
  PtiConfig,
  PtiTransferRequest,
  PtiTransferResponseItem,
  PtiReceivedData
} from "@/types/pti";

async function create(data: PtiTransferRequest) {
  const response = await http
    .postData("/transfer-internal", data)
    .catch(err => {
      console.log(err);
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  // Controller mengembalikan { success, data: item } — kembalikan itemnya.
  return response.data.data;
}

async function update(id: number, data: PtiTransferRequest) {
  const response = await http
    .putData(`/transfer-internal/${id}`, data)
    .catch(err => {
      console.log(err);
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: PtiTransferResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/transfer-internal`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getByUnit(
  id: number | string
): Promise<{ status: number; data: PtiTransferResponseItem[] }> {
  const response = await http
    .getData(`/transfer-internal?to_unit_id=${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/transfer-internal/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteDataParam(`/transfer-internal/${id}`, {
      params: {
        //alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function receive(id: number, payload: PtiReceivedData) {
  const response = await http
    .postData(`/transfer-internal/${id}/penerimaan`, payload)
    .catch(err => {
      console.log(err);
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function arrive(
  id: number,
  unitId: string | null | undefined,
  password?: string
) {
  const response = await http
    .postData(`/transfer-internal/${id}/kedatangan`, {
      unit_id: unitId ?? null,
      password: password || null
    })
    .catch(err => {
      console.log(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getConfig(): Promise<PtiConfig> {
  const response = await http
    .getData(`/transfer-internal/config`)
    .catch(err => {
      console.log(err);
      return Promise.reject(err);
    });

  return response.data.data;
}

export default {
  create,
  update,
  arrive,
  getConfig,
  getByRegister,
  find,
  destroy,
  getByUnit,
  receive
};
